
import { WeddingEventImage } from 'ignite360-core';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
  name: 'like-button',
})
export default class LikeButton extends Vue {
  @Prop({ required: true }) image!: WeddingEventImage;

  likesCount = 0;
  optimisticIsLiked = false;
  optimisticUpdate = false;
  likeAnimation = 0;
  unlikeAnimation = 0;

  @Watch('image', { immediate: true, deep: true })
  private reset() {
    this.likesCount = this.image?.likes?.length || 0;
    this.optimisticIsLiked =
      this.image?.likes?.some(
        (like) => like.userSessionId === localStorage.getItem('userSessionId'),
      ) || false;
    this.optimisticUpdate = false;
  }

  // animate on every change of the state, also when liked by double tapping the image
  @Watch('isLiked')
  private animate(liked: boolean, wasLiked: boolean) {
    if (liked && !wasLiked) this.likeAnimation++;
    if (!liked && wasLiked) this.unlikeAnimation++;
  }

  toggleLike() {
    // Update UI optimistically
    this.optimisticUpdate = true;
    this.optimisticIsLiked = !this.optimisticIsLiked;

    // Update likes count optimistically
    if (this.optimisticIsLiked) {
      this.likesCount += 1;
    } else {
      this.likesCount = Math.max(0, this.likesCount - 1);
    }

    // Emit event for actual API update
    this.$emit('toggle-like', this.image);
  }

  get isLiked(): boolean {
    return this.optimisticUpdate
      ? this.optimisticIsLiked
      : !!this.image?.likes?.some(
          (like) => like.userSessionId === localStorage.getItem('userSessionId'),
        );
  }
}
